import {combineReducers} from "redux"

import app from "./app/reducers"
import userProfile from "./userProfile/reducers"
import todolist from "./todolist/reducers"
import dnd from "./dnd/reducers"
import payment from "./payment/reducers"

export default combineReducers({
  app,
  userProfile,
  todolist,
  dnd,
  payment
})
